export const industries = {
  breadcrumb: {
    home: 'Accueil',
    industries: 'Industries',
  },
  hero: {
    title: 'Industries que Nous Servons',
    subtitle: 'Fourniture de solutions de filtration et de purification spécialisées dans plusieurs secteurs avec une expertise prouvée et une excellence technique',
  },
  grid: {
    exploreSolutions: 'Explorer les Solutions',
  },
  detail: {
    clickToView: 'Cliquez pour voir les solutions détaillées',
    overview: 'Aperçu',
    challenges: 'Défis de l\'Industrie',
    recommendedTech: 'Technologies & Produits Recommandés',
    successStory: 'Histoire de Succès',
    viewProducts: 'Voir les Produits',
    exploreTechnologies: 'Explorer les Technologies',
    requestConsultation: 'Demander une Consultation',
  },
  cta: {
    title: 'Solutions Transversales',
    subtitle: 'Nos technologies de filtration polyvalentes et notre approche d\'ingénierie sur mesure nous permettent de servir diverses industries avec des solutions adaptées à des besoins spécifiques',
    requestConsultation: 'Demander une Consultation Spécifique à l\'Industrie',
  },
  items: {
    foodBeverage: {
      name: 'Industrie Agroalimentaire & Boissons',
      description: 'Solutions complètes de filtration et de purification pour la transformation alimentaire, la production de boissons et la fabrication d\'ingrédients, assurant la qualité, la sécurité et la conformité réglementaire des produits.',
      challenges: [
        'Maintenir la clarté et la stabilité du produit',
        'Respecter les réglementations strictes de sécurité alimentaire',
        'Prévenir la contamination microbienne',
        'Réduire les coûts de production',
        'Minimiser la perte de produit',
      ],
      technologies: [
        { name: 'Microfiltration', use: 'Clarification et stérilisation des boissons' },
        { name: 'Ultrafiltration', use: 'Concentration et récupération des protéines' },
        { name: 'Filtration en Profondeur', use: 'Clarification du vin et de la bière' },
        { name: 'Filtration à Membrane', use: 'Traitement et concentration laitière' },
      ],
      caseExample: {
        title: 'Optimisation de la Production de Jus',
        result: 'Réduction de 40% des coûts filtre, amélioration de la clarté de 95%',
      },
    },
    foodService: {
      name: 'Solutions de Filtration pour la Restauration',
      description: 'Systèmes de filtration spécialisés conçus pour assurer une eau propre, une pureté de gaz et une efficacité des équipements dans les restaurants, cafés et environnements de transformation alimentaire. Accent sur la filtration de l\'eau, la qualité des boissons, la protection des équipements et la sécurité alimentaire.',
      challenges: [
        'Accumulation de tartre dans les équipements',
        'Chlore affectant le goût et causant la corrosion',
        'Sédiments obstruant les systèmes et buses',
        'Formation de biofilm dans les machines à glaçons',
        'Maintenir une qualité de boisson constante',
      ],
      technologies: [
        { name: 'Purification du Dioxyde de Carbone', use: 'Purification du CO₂ pour boissons gazeuses, élimination des contaminants, assurant la qualité et la sécurité des boissons' },
        { name: 'Filtration Machine à Glaçons', use: 'Prévention de l\'accumulation de tartre, formation de biofilm, amélioration de la qualité des glaçons et prolongation de la durée de vie des équipements' },
        { name: 'Filtration Café/Boissons Chaudes', use: 'Réduction du tartre, amélioration du goût, augmentation de l\'efficacité, prévention de l\'obstruction par sédiments' },
        { name: 'Systèmes Fontaines à Boissons', use: "Amélioration du goût des boissons (les post-mix sont à 83% d'eau), prévention des dommages par sédiments et de la turbidité" },
        { name: "Filtration Eau Potable", use: 'Élimination du chlore, sédiments, COV, plomb et kystes pour la santé et l\'amélioration du goût' },
        { name: 'Filtration Four à Vapeur/Combi', use: "Protection des équipements de cuisine coûteux utilisant la filtration par résine et l'osmose inverse (RO)" },
      ],
      caseExample: {
        title: "Amélioration Qualité Eau Chaîne de Restaurants",
        result: 'Amélioration du goût des boissons, réduction de 60% des coûts de maintenance',
      },
    },
    pharmaceutical: {
      name: 'Industrie Pharmaceutique & Chimique',
      description: 'Solutions de filtration et de séparation ultra-pure pour la fabrication pharmaceutique, la production de principes actifs et le traitement chimique, répondant aux exigences GMP et réglementaires strictes.',
      challenges: [
        "Atteindre une pureté de qualité pharmaceutique",
        'Maintenir la conformité GMP',
        'Valider les processus de filtration',
        'Prévenir la contamination croisée',
        "Assurer la cohérence des lots",
      ],
      technologies: [
        { name: 'Filtration Stérile', use: 'Purification et stérilisation API' },
        { name: 'Ultrafiltration', use: 'Purification des protéines et enzymes' },
        { name: 'Nanofiltration', use: 'Récupération de solvants et concentration' },
        { name: 'Filtration en Profondeur', use: 'Préfiltration et clarification' },
      ],
      caseExample: {
        title: 'Amélioration Purification API',
        result: 'Stérilité de 99,99% atteinte, réduction de 50% du temps de validation',
      },
    },
    waterTreatment: {
      name: 'Traitement de Eau & Environnement',
      description: 'Technologies avancées de purification de l\'eau, de dessalement et de traitement des eaux usées pour des applications municipales, industrielles et environnementales.',
      challenges: [
        'Répondre aux normes de qualité de l\'eau',
        'Réduire les coûts opérationnels',
        'Gérer le colmatage des membranes',
        'Traiter des sources d\'eau diverses',
        'Assurer des opérations durables',
      ],
      technologies: [
        { name: 'Osmose Inverse', use: 'Dessalement et eau ultra-pure' },
        { name: 'Ultrafiltration', use: "Eau potable et traitement des eaux usées" },
        { name: 'Microfiltration', use: 'Prétraitement et polissage' },
        { name: 'Nanofiltration', use: "Adoucissement de l'eau et élimination de contaminants" },
      ],
      caseExample: {
        title: "Purification Eau Municipale",
        result: "Qualité dépassant les normes de 20%, coûts opérationnels inférieurs de 45%",
      },
    },
    mining: {
      name: 'Industrie Minière & Métallurgique',
      description: "Solutions robustes de séparation solide-liquide et de traitement des eaux de processus pour les opérations minières, le traitement des minéraux et l'industrie d'extraction de métaux.",
      challenges: [
        'Gérer une forte teneur en solides',
        'Traiter des matériaux abrasifs',
        'Récupérer des matériaux précieux',
        'Traiter les eaux de processus',
        'Respecter les réglementations environnementales',
      ],
      technologies: [
        { name: 'Filtres-Presse', use: "Déshydratation des résidus et séparation solide" },
        { name: 'Filtration Grossière', use: 'Prétraitement des eaux de processus' },
        { name: 'Filtration à Membrane', use: 'Récupération et réutilisation de l\'eau' },
        { name: 'Séparation Centrifuge', use: 'Séparation solide-liquide à haute capacité' },
      ],
      caseExample: {
        title: "Récupération Eau de Résidus",
        result: "Récupération de 70% de l'eau, impact environnemental réduit",
      },
    },
    oilGas: {
      name: 'Industrie Pétrole & Gaz',
      description: 'Solutions de filtration haute performance pour les opérations en amont, en aval et en aval, incluant le traitement des eaux de production et la purification des produits.',
      challenges: [
        "Gérer des conditions d'opération difficiles",
        "Traiter les eaux de production",
        "Éliminer les contaminants des produits",
        'Protéger les équipements en aval',
        'Respecter les normes environnementales',
      ],
      technologies: [
        { name: 'Filtration Coalescente', use: 'Séparation huile-eau' },
        { name: 'Filtration à Membrane', use: "Traitement des eaux de production" },
        { name: 'Filtration en Profondeur', use: 'Purification de produits' },
        { name: 'Filtration Haute Pression', use: 'Traitement des flux de processus' },
      ],
      caseExample: {
        title: "Traitement Eaux de Production",
        result: "Récupération de 95% de l'eau, conformité réglementaire atteinte",
      },
    },
  },
};